module.exports = __webpack_public_path__ + "static/media/mastercard.05317acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/mastercard.png
// module id = 1983
// module chunks = 0